import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import FransPic from "../../assets/images/aboutus-page/franz_headshot.png";
import JacPic from "../../assets/images/aboutus-page/jack_headshot.png";

const PREFIX = "BlueContainer";

const classes = {
  blueContainer: `${PREFIX}-blueContainer`,
  leftSection: `${PREFIX}-leftSection`,
  rightSection: `${PREFIX}-rightSection`,
  profileImage: `${PREFIX}-profileImage`,
  name: `${PREFIX}-name`,
  designation: `${PREFIX}-designation`,
  email: `${PREFIX}-email`,
  content: `${PREFIX}-content`,
  contentImage: `${PREFIX}-contentImage`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.blueContainer}`]: {
    margin: "2% auto 0 auto",
    borderRadius: "50px",
    background: "#F0F8FF",
    padding: "16px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
    height: "100%",
    marginBottom: "2%",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "90%",
    },
    [theme.breakpoints.between("md", "lg")]: {
      width: "90%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "90%",
    },
  },
  [`& .${classes.leftSection}`]: {
    borderRight: "1px solid #e1e1e1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "16px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  [`& .${classes.rightSection}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "16px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  [`& .${classes.profileImage}`]: {
    width: "60%",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  [`& .${classes.name}`]: {
    fontSize: 24,
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    fontFamily: "AvenirLTStd-Roman",
  },
  [`& .${classes.designation}`]: {
    fontSize: 18,
    marginTop: theme.spacing(1),
    fontFamily: "AvenirLTStd-Book",
  },
  [`& .${classes.email}`]: {
    fontSize: 16,
    marginTop: theme.spacing(1),
    fontFamily: "AvenirLTStd-Book",
  },
  [`& .${classes.content}`]: {
    fontSize: 20,
    fontFamily: "AvenirLTStd-Book",
    marginBottom: theme.spacing(2),
    lineHeight: "180%",
    padding: "1%",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  [`& .${classes.contentImage}`]: {
    width: "60%",
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginBottom: theme.spacing(2),
    },
  },
}));

function ContactTeam() {
  return (
    <StyledGrid size={{ xs: 12 }}>
      <Typography sx={{ fontWeight: 100, fontSize: "30px", mb: 2, mt: 3, textAlign: "center" }}>
        Contact Our Team
      </Typography>
      <div className={classes.blueContainer}>
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid
            size={{ xs: 11, sm: 5, md: 5, lg: 5 }}
            className={classes.leftSection}
          >
            <img src={JacPic} alt="Profile" className={classes.contentImage} />

            <div>
              <Typography variant="h6" className={classes.name}>
                Jack Clancy
              </Typography>
              <Typography variant="body1" className={classes.designation}>
                Product Specialist & Head of Sales{" "}
              </Typography>
              <Typography variant="body2" className={classes.email}>
                Email: jack@redifly.com{" "}
              </Typography>
            </div>
          </Grid>
          <Grid
            size={{ xs: 11, sm: 5, md: 5, lg: 5 }}
            className={classes.rightSection}
          >
            <div>
              <Typography variant="h6" className={classes.name}>
                Franz Beier
              </Typography>
              <Typography variant="body1" className={classes.designation}>
                Sales & Business Development Director APAC
              </Typography>
              <Typography variant="body2" className={classes.email}>
                Email: franz@redifly.com{" "}
              </Typography>
            </div>
            <img
              src={FransPic}
              alt="Profile"
              className={classes.profileImage}
            />
          </Grid>
        </Grid>
      </div>
    </StyledGrid>
  );
}

export default ContactTeam;
